
export enum UserStatus {
  new = 'nový',
  newUser = 'nový',
  approved = 'schválený',
  canceled = 'zrušený',
}

export const BLAH = 123;